function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.545 2.438a1.547 1.547 0 00-.96-.196h-.006A5.3 5.3 0 002.95 7.5 13.55 13.55 0 0016.5 21.05a5.3 5.3 0 005.258-4.629v-.005a1.547 1.547 0 00-.93-1.61l-4.39-1.881a1.55 1.55 0 00-1.47.135l-2.323 1.55a7.108 7.108 0 01-3.24-3.226l1.544-2.36a1.55 1.55 0 00.128-1.459L9.194 3.173V3.17a1.547 1.547 0 00-.65-.733zm1.05 5.733L7.739 3.835A3.7 3.7 0 004.55 7.5 11.95 11.95 0 0016.5 19.45a3.7 3.7 0 003.665-3.188l-4.332-1.856-2.32 1.548-.003.001a1.544 1.544 0 01-1.522.114l-.005-.003a8.707 8.707 0 01-4.032-4.013l-.003-.006a1.543 1.543 0 01.104-1.517z",
    fill: props.fill,
    fillRule: "evenodd"
  }));
}

export default SvgPhone;